<template>
  <div >
    <!-- 暂无用到，pc端和移动端页面合并在一起 -->
    <!-- <div class="page d-flex flex-column" id="page1">
      <v-header></v-header>
    	<div class="flex-fill ">
    		<div class="d-flex align-items-center mar-top20">
    			<div class="d-flex" style="margin-left:33%;">
    				<div class="videobox d-flex align-items-center justify-content-center">
    					<video width="300px" autoplay="autoplay" muted="muted" src="../../assets/video/index/showVideo.mp4" preload="auto" loop="loop" ></video>
    				</div>
    				<div class="iphone-bg d-flex align-items-center justify-content-center"></div>
    			</div>
    			<div class="mar-left50">
    				<h1 class="c-ffffff">兴趣百科</h1>
    				<div class="fz22 font-weight-bold c-ffffff">培养您的兴趣爱好</div>
    				<div class="fz22 font-weight-bold mar-top10 c-ffffff">迈向成功的殿堂！</div>
    				<img src="../../assets/img/index/miniProjectImg.jpg" style="width:180px;height:180;border-radius:10px" class="border2 mar-top20">
    				<div style="margin-top:20px;" class="c-ffffff">请使用微信扫码了解更多</div>
    			</div>
    		</div>
    	</div>

      <v-footer></v-footer>
    </div> -->
  </div>

</template>

<script>
import header from '@/pages/pc/header';
import footer from '@/pages/pc/footer';
export default {
  name: 'pcIndex',
  components:{
    'v-header':header,
    'v-footer':footer
  },
  data () {
    return {

    }
  },
  mounted(){//页面加载后，调用接口数据

  },
  methods:{


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  #page1 #header{background:none}
  #page1 #header a{color:#fff}
  #page1 #footer a{color:#fff}
</style>



// WEBPACK FOOTER //
// src/pages/pc/index.vue